import { Variant, Variants } from 'framer-motion';

type MotionVariants = {
  initial: Variant;
  animate: Variant;
  exit: Variant;
  [key: string]: Variant;
}

interface CreateReducedMotionVariantsOptions {
  /**
   * Variants for normal motion
   */
  regular: MotionVariants;
  
  /**
   * Optional variants for reduced motion
   * If not provided, defaults to a simple fade effect
   */
  reduced?: MotionVariants;
}

/**
 * Creates motion variants that respect reduced motion preferences
 */
export function createReducedMotionVariants({
  regular,
  reduced = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
}: CreateReducedMotionVariantsOptions) {
  return (prefersReducedMotion: boolean): Variants => {
    return prefersReducedMotion ? reduced : regular;
  };
}

/**
 * Standard animation variants for page transitions
 */
export const pageVariants = createReducedMotionVariants({
  regular: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  },
});

/**
 * Standard animation variants for fade-up animations
 */
export const fadeUpVariants = createReducedMotionVariants({
  regular: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
  },
});

/**
 * Standard animation variants for fade-down animations
 */
export const fadeDownVariants = createReducedMotionVariants({
  regular: {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  },
}); 